import { render, staticRenderFns } from "./OpportunitiesMap.vue?vue&type=template&id=28004130"
import script from "./OpportunitiesMap.vue?vue&type=script&lang=js"
export * from "./OpportunitiesMap.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesMap.vue?vue&type=style&index=0&id=28004130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports